// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__18onx","title":"ClientCherryInfo_title__3gx0I","itemText":"ClientCherryInfo_itemText__30Dpo"};